import { useState } from 'react';
import html2canvas from 'html2canvas';
import { CloneOptions } from 'html2canvas/dist/types/dom/document-cloner';

// temporary solution as https://github.com/vre2h/use-react-screenshot does not support options

const useScreenshot = ({
  type,
  quality,
}: {
  type: string;
  quality: number;
}): [
  string | undefined,
  (node: HTMLElement, option?: CloneOptions & { useCORS: boolean }) => Promise<string | void>,
  unknown,
] => {
  const [image, setImage] = useState<string>();
  const [error, setError] = useState<unknown>(null);

  const takeScreenShot = async (
    node: HTMLElement,
    option?: Partial<CloneOptions> & { useCORS: boolean },
  ): Promise<string | void> => {
    if (!node) {
      throw new Error('You should provide correct html node.');
    }
    const canvas = await html2canvas(node, option);
    try {
      const croppedCanvas = document.createElement('canvas');
      const croppedCanvasContext = croppedCanvas.getContext('2d');
      // init data
      const cropPositionTop = 0;
      const cropPositionLeft = 0;
      const cropWidth = canvas.width;
      const cropHeight = canvas.height;

      croppedCanvas.width = cropWidth;
      croppedCanvas.height = cropHeight;

      croppedCanvasContext?.drawImage(canvas, cropPositionLeft, cropPositionTop);

      const base64Image = croppedCanvas.toDataURL(type, quality);

      setImage(base64Image);
      return base64Image;
    } catch (e) {
      setError(e);
    }
  };

  return [image, takeScreenShot, { error }];
};

const createFileName = (extension = '', ...names: string[]) => {
  if (!extension) {
    return '';
  }

  return `${names.join('')}.${extension}`;
};

export { useScreenshot, createFileName };
